(function() {
  "use strict";
  angular.module("marketPlace.dashboard", ["marketPlace.games", "marketPlace.lodash"]);
})();
